export default "__VITE_ASSET__Cz8sEOUh__"